import { GridColumnMenuPinningItem } from "@mui/x-data-grid-pro";

export const jaJPText = {
    noRowsLabel: 'データがありません',
    columnMenuLabel: 'メニュー',
    columnMenuShowAll: '全て表示',
    columnMenuSortAsc: '昇順ソート',
    columnMenuSortDesc: '降順ソート',
    columnMenuUnsort: 'ソート解除',
    columnMenuHideColumn: '列を非表示',
    columnMenuManageColumns: '列の表示/非表示',
    columnMenuFilter: 'フィルター',
    columnMenuSortSeparator: 'ソート',
    footerTotalRows:`総件数`,

  };